import { render, staticRenderFns } from "./category-banners.vue?vue&type=template&id=07b00700&"
import script from "./category-banners.vue?vue&type=script&lang=js&"
export * from "./category-banners.vue?vue&type=script&lang=js&"
import style0 from "./category-banners.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07b00700')) {
      api.createRecord('07b00700', component.options)
    } else {
      api.reload('07b00700', component.options)
    }
    module.hot.accept("./category-banners.vue?vue&type=template&id=07b00700&", function () {
      api.rerender('07b00700', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/category-banners/category-banners.vue"
export default component.exports